module.exports = __webpack_public_path__ + "static/media/5yr-au-cny.dac5ba5a.png";